var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomModal', {
    attrs: {
      "name": "uploadModal",
      "customClass": "generic-modals v--modal new-modal",
      "width": "75%",
      "height": "auto",
      "maxWidth": 500,
      "clickToClose": false,
      "customRef": "vueUploadModal"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "new-modal-wrapper customs-tools new-modal-wrapper-no-buttons",
      "elementType": "section"
    }
  }, [_c('ModalHeader', {
    attrs: {
      "backDisabled": true,
      "closeDisabled": true,
      "headerImg": true,
      "includeClose": false,
      "includeBack": false
    }
  }), _c('UgcUploading', {
    attrs: {
      "customsClass": "new-modal-main-views-wrapper new-file-upload",
      "modalTitle": _vm.translations.uploadModalHeader,
      "topSubtitle": _vm.translations.uploadModalSubHeader1,
      "bottomSubtitle": _vm.translations.uploadModalSubHeader2
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }